import React from "react";
import { useTranslation } from "react-i18next";

import { useFacilityReport } from "./hook";
import { AccountType } from "../../../models/AccountData";
import { OptionalRender } from "../../Common/OptionalRender";

import "./styles.scss";

interface IFacilityReportDetailsProps {
  facilityReportId: string;
}

export const FacilityReportDetails: React.FunctionComponent<
  IFacilityReportDetailsProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);

  const { facilityReportId } = props;

  const { data: facilityReport, isLoading } =
    useFacilityReport(facilityReportId);

  // TODO: Implement download
  const handleDownload = () => {
    alert("download not yet implemented");
  };

  // TODO: Implement edit
  const handleEdit = () => {
    alert("edit not yet implemented");
  };

  return (
    <div className="facility-report-details">
      <div className="facility-report-details-title">
        <h2>{facilityReport?.location?.name}</h2>
      </div>
      <div className="line"></div>
      <div className="facility-report-details-controls">
        <span>TODO: Select Report (same location) Here</span>
        <button className="btn btn-blue" type="button" onClick={handleDownload}>
          {t("download")}
        </button>
        <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
          <button className="btn btn-border" type="button" onClick={handleEdit}>
            {t("edit")}
          </button>
        </OptionalRender>
      </div>
      <div className="facility-report-details-content">
        <div className="facility-report-details-content-item white-border-panel">
          {isLoading ? (
            <span>Loading...</span>
          ) : (
            <span>
              TODO: Report Data Here{" "}
              {JSON.stringify(facilityReport?.report_data)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
